import { IsArray } from 'class-validator';
import { CnxIdType, IsCnxId } from '@cnx-saas/utils-cnx-id';
import { IsValidNumber } from '../validators';

export function BaseFilterOne(cnxIdType: CnxIdType) {
  abstract class BaseFilterOne {
    @IsCnxId(cnxIdType)
    id: string;

    @IsValidNumber({ integer: true, min: 1, optional: true })
    version?: number;
  }
  return BaseFilterOne;
}

export function BaseFilterMany(cnxIdType: CnxIdType) {
  abstract class BaseFilterMany {
    @IsArray()
    @IsCnxId(cnxIdType, { each: true })
    ids: string[];
  }
  return BaseFilterMany;
}

export type BaseQueryManyInterface<Filter> = {
  skip?: number;
  take?: number;
  sort?: Record<string, 1 | -1>;
  filters?: Filter[];
};

export function BaseQueryMany<Filter>() {
  abstract class BaseQueryMany implements BaseQueryManyInterface<Filter> {
    @IsValidNumber({ integer: true, min: 0, optional: true })
    skip?: number;

    @IsValidNumber({ integer: true, min: 1, max: 500, optional: true })
    take?: number;

    filters?: Filter[];

    sort?: Record<string, 1 | -1>;
  }
  return BaseQueryMany;
}

export abstract class BaseOne {
  id: string;
  version?: number;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date;
}

export abstract class BaseMany<Item> {
  totalCount: number;
  filteredCount: number;
  itemList: Item[];
}

export type BaseBulkError = {
  itemId?: string;
  index: number;
  message: string;
  messageKey: string;
  data?: object;
};

export type BaseBulk = {
  successfulCount: number;
  failedErrors: BaseBulkError[];
};

export type BaseBulkV2 = {
  successfulIds: string[];
  failedErrors: BaseBulkError[];
};

// NOTE: base document database schema
export abstract class BaseSchema {
  id: string;
  version?: number;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date;
}

// NOTE: base relational database entity
export abstract class BaseEntity {
  id: string;
  version?: number;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
}
